<template>
  <div
    :class="[
      startProjectPop || awardsPop || recruitPop || pdsPop ? 'typeClose white' : '',
      navigation || culturePop ? 'typeClose' : '',
      readyAction ? 'ready-action' : '',
      $route.meta.themes === 'white' && !navigation ? 'white' : ''
    ]"
    class="rnb"
  >
    <div class="menu">
      <a href="javascript:;" @click.prevent="navigationCall" />
    </div>
    <menu-area />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import MenuArea from '@/components/Menu';

export default {
  name: 'RNB',
  components: {
    MenuArea
  },
  computed: {
    ...mapState('common', {
      readyAction: state => state.readyAction,
      navigation: state => state.navigation,
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      pdsPop: state => state.pdsPop,
      culturePop: state => state.culturePop,
      awardsPop: state => state.awardsPop
    })
  },
  watch: {
    pdsPop(value) {
      if (value == true) {
        let popArea = document.querySelector('.popArea.active');
        let visualWrapper = document.querySelector('.visual');

        popArea.addEventListener('scroll', () => {
          let visualH = visualWrapper.clientHeight;
          let scrollY = popArea.scrollTop;
          let closebtn = document.querySelector('.typeClose');
          if (scrollY > visualH) {
            // console.log('ok');
            closebtn.classList.remove('white');
          } else {
            closebtn.classList.add('white');
          }
        });
      }
    }
  },
  methods: {
    ...mapActions('common', {
      setNavigationAction: 'setNavigation',
      setStartProjectPopAction: 'setStartProjectPop',
      setRecruitPopAction: 'setRecruitPop',
      setPdsPopAction: 'setPdsPop',
      setAwardsPopAction: 'setAwardsPop',
      setCulturePopAction: 'setCulturePop'
    }),
    navigationCall() {
      if (this.startProjectPop) {
        this.setStartProjectPopAction(false);
        return false;
      }
      if (this.recruitPop) {
        this.setRecruitPopAction(false);
        return false;
      }
      if (this.pdsPop) {
        this.setPdsPopAction(false);
        return false;
      }
      if (this.awardsPop) {
        this.setAwardsPopAction(false);
        return false;
      }
      if (this.culturePop) {
        this.setCulturePopAction(false);
        return false;
      }
      this.setNavigationAction(!this.navigation);
    }
  }
};
</script>
